<template>
  <section id="PaginateBase">
    <!-- <section class="PaginateUnderBase"> -->
    <slot></slot>
    <!-- </section> -->

    <div class="navsystem mainContainer" v-if="nbrOfPages > 1">
      <div class="caseBox">
        <div @click="changePage(page-1)">
          <i class="fas fa-angle-left"></i>
        </div>

        <div
          v-for="index in nbrOfPages "
          @click="changePage(index-1)"
          :class="index-1 == page? 'current':'' "
          :key="index"
        >
          <i>{{ index }}</i>
        </div>

        <div @click="changePage(page+1)">
          <i class="fas fa-angle-right"></i>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Pagination",

  data: function() {
    return {
      baseCompEl: null,
      itemContainerEl: null,
      itemsQuantity: 0,
      itemSize: 0,
      page: 0,
      nbrOfPages: 0
    };
  },

  computed: {},
  props: ["nbritemsbypage"],

  computed: {
    itemPerView: {
      get() {
        return parseInt(this.nbritemsbypage);
      }
    }
  },

  created: function() {},
  mounted: function() {
    this.$nextTick(function() {
      this.baseCompEl = document.getElementById("PaginateBase");
      this.itemContainerEl = this.baseCompEl.children[0];
      this.itemsQuantity = this.itemContainerEl.children.length;
      this.nbrOfPages = Math.ceil(this.itemsQuantity / this.itemPerView);

      this.showWhatToShow();
    });
  },
  methods: {
    changePage(newpage) {
      this.page = newpage;
      if (this.page < 0) {
        this.page = 0;
      } else if (this.page > this.nbrOfPages - 1) {
        this.page = this.nbrOfPages - 1;
      }
      this.showWhatToShow();
    },

    showWhatToShow() {
      const interval = this.page * this.itemPerView;
      for (var i = 0; i < this.itemsQuantity; i++) {
        if (i >= interval && i < interval + this.itemPerView) {
          if (
            this.itemContainerEl.children[i].classList.contains(
              "pagItemsToHide"
            )
          ) {
            this.itemContainerEl.children[i].classList.remove("pagItemsToHide");
          }
        } else {
          this.itemContainerEl.children[i].classList.add("pagItemsToHide");
        }
      }
    }
  }
};
</script>

<style>
.navsystem {
  border-top: 1px rgb(54, 54, 54) solid;
  border-bottom: 1px rgb(54, 54, 54) solid;
  border-left: 1px rgb(54, 54, 54) solid;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  margin: 0 auto;
}
.pagItemsToHide {
  display: none !important;
}

.caseBox {
  display: flex;
  flex-wrap: wrap;
}

.caseBox div {
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px rgb(54, 54, 54) solid;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.caseBox div:hover {
  background: var(--main-color);
  color: white;
}

.caseBox i {
  font-style: normal;
  font-size: 1.3em;
}

.current {
  /* background: rgb(35, 35, 35); */
  color: var(--main-color);
}

.viewStyle i {
  margin: 0 8px;
  font-size: 1.5em;
  cursor: pointer;
}

/* .casebox i:hover {
  color: var(--main-color);
} */

@media all and (max-width: 1000px) {
  .navsystem {
    flex-wrap: wrap;
    border: none;
    margin-top: 8px;
  }
  .caseBox {
    width: 100%;
    margin-top: 1rem;
    border: 1px rgb(54, 54, 54) solid;
    order: 1;
  }
}
</style>
